/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../layout/menu.component.ngfactory';
import * as import2 from '../../../app/layout/menu.component';
import * as import3 from '../../../app/services/menu.service';
import * as import4 from '../../../app/services/conversations.service';
import * as import5 from '@angular/common';
import * as import6 from '@angular/router';
import * as import7 from '../../../app/panel/panel.component';
import * as import8 from '../../../app/services/local-storage.service';
const styles_PanelComponent:any[] = ([] as any[]);
export const RenderType_PanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PanelComponent,
  data: {}
}
);
function View_PanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-menu',([] as any[]),(null as any),(null as any),(null as any),import1.View_MenuComponent_0,import1.RenderType_MenuComponent)),
    import0.ɵdid(2211840,(null as any),0,import2.MenuComponent,[
      import3.MenuService,
      import4.ConversationsService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export function View_PanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(147456,(null as any),0,import6.RouterOutlet,[
      import6.RouterOutletMap,
      import0.ViewContainerRef,
      import0.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:import7.PanelComponent = v.component;
    const currVal_0:any = co.selectedCompany;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_PanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_PanelComponent_0,RenderType_PanelComponent)),
    import0.ɵdid(114688,(null as any),0,import7.PanelComponent,[import8.LocalStorageService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PanelComponentNgFactory:import0.ComponentFactory<import7.PanelComponent> = import0.ɵccf('app-main',import7.PanelComponent,View_PanelComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYW5lbC9wYW5lbC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9zcmMvYXBwL3BhbmVsL3BhbmVsLmNvbXBvbmVudC50cyIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYW5lbC9wYW5lbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYW5lbC9wYW5lbC5jb21wb25lbnQudHMuUGFuZWxDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLW1lbnUgKm5nSWY9XCJzZWxlY3RlZENvbXBhbnlcIj48L2FwcC1tZW51PlxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiIsIjxhcHAtbWFpbj48L2FwcC1tYWluPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7Z0JBQUE7OztJQUFBO0tBQUE7OztJQUFBOzs7OztJQUFBO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBNkM7SUFDN0M7Z0JBQUE7Ozs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBOzs7O0lBRFU7SUFBVixTQUFVLFNBQVY7Ozs7O0lDQUE7Z0JBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/panel/panel.component.ngfactory.ts